import React from 'react';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const CloseButton = ({ history, to }) => {
    const handleClick = () => {
        history.push(to);
    };
    return (
        <IconButton
            style={{ position: 'absolute', top: 10, right: 10 }}
            onClick={handleClick}
        >
            <CloseIcon fontSize="large" style={{ color: 'var(--grey)' }} />
        </IconButton>
    );
};

export default CloseButton;
